// extracted by mini-css-extract-plugin
export default {"p404":"_404_p404__HAo5-","buttonGroup":"_404_buttonGroup__zaX3e"};